import React from "react";
import svgPaths from "./svgPaths";
import imgDiv8 from "../assets/images/how it works - book.png";
import imgDiv9 from "../assets/images/How it works - connect.png";
import imgDiv10 from "../assets/images/How it works -relax.png";

function HowItWorksCTA() {
  const scrollToContact = () => {
    window.scrollTo({
      top: 9165,
      behavior: "smooth"
    });
  };

  return (
    <button 
      onClick={scrollToContact}
      className="bg-[#107cf7] px-8 py-4 rounded-full text-white font-['Inter:Medium',sans-serif] font-medium hover:bg-blue-600 transition-colors shadow-md tracking-wider text-sm lg:text-base"
    >
      BOOK NOW
    </button>
  );
}

function HowItWorksIntro() {
  return (
    <div className="w-full flex flex-col lg:flex-row gap-6 justify-between items-start" data-name="div">
      <h2 className="font-['Inter:Regular',sans-serif] font-normal leading-tight text-4xl md:text-6xl lg:text-[128px] text-black tracking-[-3px] w-full lg:w-[439px]">
        How it works
      </h2>
      <div className="flex flex-col gap-6 items-start w-full lg:w-[567px] pt-4" data-name="div">
        <p className="font-['Inter:Regular',sans-serif] font-normal text-base md:text-xl text-[#3d3d3d] leading-relaxed">
          From booking to completion, Fixezy makes every step effortless. Choose a service, schedule a convenient time, and let verified professionals take care of the rest.
        </p>
        <HowItWorksCTA />
      </div>
    </div>
  );
}

// Step 1 helper
function Frame() {
  return (
    <div className="-translate-x-1/2 absolute left-1/2 size-[80px] top-0" data-name="Frame">
      <svg className="absolute block inset-0 size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 80 80">
        <g id="Frame">
          <path clipRule="evenodd" d={svgPaths.p31074d00} fill="var(--fill-0, black)" fillRule="evenodd" id="Vector" />
        </g>
      </svg>
    </div>
  );
}
function Svg() {
  return (
    <div className="absolute left-0 overflow-clip size-[80px] top-0" data-name="svg">
      <Frame />
    </div>
  );
}
function Div10() {
  return (
    <div className="h-[84.797px] relative shrink-0 w-[80px]" data-name="div">
      <Svg />
    </div>
  );
}
function Div9() {
  return (
    <div className="absolute content-stretch flex gap-[9.531px] items-start left-0 pr-[21.469px] top-[34px]" data-name="div">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[70.4px] text-[59px] text-black tracking-[-2px] whitespace-nowrap">
        Book
      </p>
      <Div10 />
    </div>
  );
}
function Step1Card() {
  return (
    <div className="relative w-full h-[280px] lg:absolute lg:h-[209.984px] lg:left-0 lg:top-[50%] lg:-translate-y-1/2 lg:w-[288px]" data-name="div">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-normal text-lg text-black mb-2 lg:absolute lg:top-[13px] lg:left-0 lg:mb-0">
        Step 1
      </p>
      <div className="relative w-full h-[85px] lg:absolute lg:top-[34px] lg:left-0">
        <Div9 />
      </div>
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-relaxed text-[15px] text-black/80 mt-4 lg:absolute lg:top-[167px] lg:left-0 lg:w-[281px] lg:mt-0">
        Browse services, select a convenient time, and confirm your booking instantly.
      </p>
    </div>
  );
}

// Step 2 helper
function Frame1() {
  return (
    <div className="-translate-x-1/2 absolute left-1/2 size-[74px] top-0" data-name="Frame">
      <svg className="absolute block inset-0 size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 74 74">
        <g id="Frame">
          <path clipRule="evenodd" d={svgPaths.p2cc69200} fill="var(--fill-0, black)" fillRule="evenodd" id="Vector" />
        </g>
      </svg>
    </div>
  );
}
function Svg1() {
  return (
    <div className="absolute left-0 overflow-clip size-[74px] top-[0.02px]" data-name="svg">
      <Frame1 />
    </div>
  );
}
function Div14() {
  return (
    <div className="h-[78.813px] relative shrink-0 w-[74.016px]" data-name="div">
      <Svg1 />
    </div>
  );
}
function Div13() {
  return (
    <div className="absolute content-stretch flex gap-[10.984px] items-start left-0 top-[34px]" data-name="div">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[70.4px] text-[60px] text-black tracking-[-2px] whitespace-nowrap">
        Connect
      </p>
      <Div14 />
    </div>
  );
}
function Step2Card() {
  return (
    <div className="relative w-full h-[280px] lg:absolute lg:h-[183.203px] lg:left-0 lg:top-[50%] lg:-translate-y-1/2 lg:w-[288px]" data-name="div">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-normal text-lg text-black mb-2 lg:absolute lg:top-[13px] lg:left-0 lg:mb-0">
        Step 2
      </p>
      <div className="relative w-full h-[85px] lg:absolute lg:top-[34px] lg:left-0">
        <Div13 />
      </div>
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-relaxed text-[14px] text-black/80 mt-4 lg:absolute lg:top-[151px] lg:left-0 lg:w-[266px] lg:mt-0">
        Browse services, select a convenient time, and confirm your booking instantly.
      </p>
    </div>
  );
}

// Step 3 helper
function Frame2() {
  return (
    <div className="-translate-x-1/2 absolute left-1/2 size-[65.688px] top-0" data-name="Frame">
      <svg className="absolute block inset-0 size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 65.6875 65.6875">
        <g id="Frame">
          <path clipRule="evenodd" d={svgPaths.p17b70700} fill="var(--fill-0, black)" fillRule="evenodd" id="Vector" />
        </g>
      </svg>
    </div>
  );
}
function Svg2() {
  return (
    <div className="absolute left-0 overflow-clip size-[65.688px] top-[0.02px]" data-name="svg">
      <Frame2 />
    </div>
  );
}
function Div18() {
  return (
    <div className="h-[70.5px] relative shrink-0 w-[65.703px]" data-name="div">
      <Svg2 />
    </div>
  );
}
function Div17() {
  return (
    <div className="absolute content-stretch flex gap-[10.297px] items-start left-0 top-[34px]" data-name="div">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[70.4px] text-[60px] text-black tracking-[-2px] whitespace-nowrap">
        Relax
      </p>
      <Div18 />
    </div>
  );
}
function Step3Card() {
  return (
    <div className="relative w-full h-[280px] lg:absolute lg:h-[174.891px] lg:left-0 lg:top-[50%] lg:-translate-y-1/2 lg:w-[288px]" data-name="div">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-normal text-lg text-black mb-2 lg:absolute lg:top-[13px] lg:left-0 lg:mb-0">
        Step 3
      </p>
      <div className="relative w-full h-[85px] lg:absolute lg:top-[34px] lg:left-0">
        <Div17 />
      </div>
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-relaxed text-[14px] text-black/80 mt-4 lg:absolute lg:top-[142px] lg:left-0 lg:w-[270px] lg:mt-0">
        Track progress, pay securely, and rate your experience—all from one place.
      </p>
    </div>
  );
}

// Timeline layout blocks
function TimelineStep1() {
  return (
    <div className="w-full flex flex-col gap-6 relative lg:absolute lg:h-[320px] lg:left-0 lg:top-[447.38px] lg:w-[1280px]" data-name="a">
      <Step1Card />
      <div className="relative w-full h-[180px] md:h-[240px] rounded-[384px] overflow-hidden lg:absolute lg:left-[336px] lg:top-1/2 lg:-translate-y-1/2 lg:right-0">
        <img alt="Book step" className="absolute h-[199.57%] left-[-0.03%] max-w-none top-[-49.84%] w-full object-cover" src={imgDiv8} />
      </div>
    </div>
  );
}

function TimelineStep2() {
  return (
    <div className="w-full flex flex-col gap-6 relative lg:absolute lg:h-[320px] lg:left-0 lg:top-[768.38px] lg:w-[1280px]" data-name="a">
      <Step2Card />
      <div className="relative w-full h-[180px] md:h-[240px] rounded-[384px] overflow-hidden lg:absolute lg:left-[336px] lg:top-1/2 lg:-translate-y-1/2 lg:right-0">
        <img alt="Connect step" className="absolute h-[165.11%] left-[-2.54%] max-w-none top-[-18.18%] w-[104.68%] object-cover" src={imgDiv9} />
      </div>
    </div>
  );
}

function TimelineStep3() {
  return (
    <div className="w-full flex flex-col gap-6 relative lg:absolute lg:h-[320px] lg:left-0 lg:top-[1089.38px] lg:w-[1280px]" data-name="a">
      <Step3Card />
      <div className="relative w-full h-[180px] md:h-[240px] rounded-[384px] overflow-hidden lg:absolute lg:left-[336px] lg:top-1/2 lg:-translate-y-1/2 lg:right-0">
        <img alt="Relax step" className="absolute h-[393.33%] left-[-0.02%] max-w-none top-[-96.67%] w-full object-cover" src={imgDiv10} />
      </div>
    </div>
  );
}

export default function HowItWorks() {
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col gap-8 px-6 py-12 lg:h-[1513.375px] lg:px-[80px] lg:py-0 lg:block lg:w-[1440px] lg:mx-auto" data-name="section">
      <div className="relative w-full flex flex-col gap-12 lg:h-[1513.375px] lg:block lg:w-[1280px]">
        <HowItWorksIntro />
        <div className="hidden lg:block absolute bg-[rgba(0,0,0,0.1)] h-px left-0 right-0 top-[446.38px]" />
        <TimelineStep1 />
        <div className="hidden lg:block absolute bg-[rgba(0,0,0,0.1)] h-px left-0 right-0 top-[767.38px]" />
        <TimelineStep2 />
        <div className="hidden lg:block absolute bg-[rgba(0,0,0,0.1)] h-px left-0 right-0 top-[1088.38px]" />
        <TimelineStep3 />
      </div>
    </div>
  );
}
